import React from 'react';
import './App.css';
import Navbar from './components/pages/Navbar';
import ProdsNServsPg from './components/pages/HomePage/ProdsNServsPg.js';
import Footer from './components/pages/Footer/Footer.js'
import Services from './components/pages/Services/Services.js'
import Products from './components/pages/Products/Products.js'
import Privacypolicy from './components/pages/Termsncond/Pivacypolicy.js'
import { BrowserRouter as Router, Routes, Route } from  'react-router-dom';
import Expressdownload from './components/pages/BBExpressDownload/BBExpressDownload.js';

function App() {
  return(

    <Router>
      <Navbar/>
       <Routes>
       <Route path='/' element={<ProdsNServsPg />} exact />
       <Route path='/services' element={<Services />} />
       <Route path='/products' element={<Products />} />
       <Route path='/privpol' element={<Privacypolicy />} />
       <Route path='/bbdownload' element={<Expressdownload />} />
       </Routes>
       <Footer />
    </Router>
  
  );
}

export default App;
